// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Toast notification component
// Renders appStore.toasts array, auto-removes after duration.
// ---------------------------------------------------------------------------

import { useAppStore } from '@/store/app-store';

const BG_MAP: Record<string, string> = {
  success: 'bg-success',
  error: 'bg-danger',
  warning: 'bg-warning',
  info: 'bg-info',
};

export default function Toast() {
  const toasts = useAppStore((s) => s.toasts);
  const removeToast = useAppStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="animate-fade-in pointer-events-auto"
          role="alert"
        >
          <div
            className={`${BG_MAP[toast.type] ?? 'bg-info'} rounded-xl px-6 py-3 shadow-lg min-w-[200px] max-w-[90vw] flex items-center gap-2`}
          >
            <p className="text-white text-sm font-semibold text-center flex-1">
              {toast.message}
            </p>
            <button
              type="button"
              onClick={() => removeToast(toast.id)}
              className="text-white/70 hover:text-white text-lg leading-none"
              aria-label="Fermer"
            >
              x
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
